import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600 py-4 px-4 md:px-6">
      <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
        <i className="ri-home-4-line mr-1"></i>
        首页
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center">
          <i className="ri-arrow-right-s-line mx-2 text-foreground-400"></i>
          {item.path ? (
            <Link to={item.path} className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}